import {
	Component,
	OnInit,
	ElementRef,
	ViewChild,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	HostListener,
	ViewChildren,
	ViewRef
} from '@angular/core';
import { DatePipe } from '@angular/common';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
// Material
import { MatPaginator, MatSort, MatDialog, MatTableDataSource, MatMenuTrigger, MatDialogRef } from '@angular/material';
// RXJS
import { ReplaySubject, fromEvent, merge, BehaviorSubject } from 'rxjs';
//Service
import { LayoutUtilsService, QueryParamsModel, MessageType } from '../../../../../../core/_base/crud';
import { SoDoKhoService } from '../so-do-kho-service/so-do-kho.service';

//Model
import { CommonConFig } from 'app/views/pages/nfc/dung-chung/__model/common_config.model';
import * as jsPDF from 'jspdf';
//Component
import { JsPDFFontService } from '../../../dung-chung/__services/pdf-custom-font.service';

@Component({
	selector: 'm-qr-pallet',
	templateUrl: './qr-pallet.component.html',
	styleUrls: ['../so-do-kho.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [DatePipe]
})

export class QrPalletComponent implements OnInit{

    /*Config Form */
	CONFIG: CommonConFig;
	viewLoading: boolean = false; 

	InfoForm: FormGroup;		
    
    loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();

	textMaxNum = '';

	//mảng QRCode
	lstQR: any[] = [];
	lstInfoQR: any[] = [];
	@ViewChild('pdfQRContainer', { static: false }) pdfQRContainer: ElementRef;

    constructor(
		public dialogRef: MatDialogRef<QrPalletComponent>,
		public dialog: MatDialog,
		private soDoKhoService: SoDoKhoService,
		private ThietLapFB: FormBuilder,
		private pdfCustomService: JsPDFFontService,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService) {
			this.dialogRef.disableClose = true;
        }
        
    /*---------------------------- LOAD DATA --------------------------------*/
	ngOnInit() {
		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();

		this.dialogRef.keydownEvents().subscribe(event => {
			if (event.key == "Escape") {
				this.back();
			}
			this.changeDetect.detectChanges();
		});

		this.soDoKhoService.getNumOfQRPallet().subscribe(res => {
			if(res && res.status == 1){
				this.textMaxNum = res.data;
				this.changeDetect.detectChanges();
			}
		})
		this.createForm();
	}
	createForm(){
		/*Group các Form */
		this.InfoForm = this.ThietLapFB.group({
			Start: [1, Validators.compose([Validators.min(1), Validators.pattern(this.CONFIG.REGEX_FORMAT_QUANTITY)])],
			Number: [1, Validators.compose([Validators.min(1), Validators.max(1000), Validators.pattern(this.CONFIG.REGEX_FORMAT_QUANTITY)])],
		});

		this.changeDetectView();
	}
	InQrPallet() {

		this.lstQR = [];
		this.lstInfoQR = [];

		let start =  this.InfoForm.controls['Start'].value;
		let loop =  this.InfoForm.controls['Number'].value

		if(start < 1 || loop < 1 || loop > 1000){
			this.layoutUtilsService.showErorr("Vui lòng nhập đúng số lượng");
			return;
		}
		
		let max = '';
		for(let k = start; k < (start + loop); k++){
			var vt = 'PL' + this.pad(k, 4);
			max = this.pad(k, 4);
			this.lstQR.push(vt);
			this.lstInfoQR.push('nfcerp://QRDeeplink?PQR=' + vt);
		}
		this.changeDetectView();
	
		var doc = new jsPDF('l', 'mm', [257, 310]);
		this.pdfCustomService.AddFontRoboto(doc);

		let pageHeight = doc.internal.pageSize.height;
		let images = this.pdfQRContainer.nativeElement.querySelectorAll('img');
		let x = 10; let y = 10;

		var text = 'QR Pallet',
			xOffset = (doc.internal.pageSize.width / 2 - 10); 

		for (var i = 0; i < images.length; i++) {
			let src = images[i].getAttribute('src');
			let subText = this.lstQR[i];

			doc.text(xOffset, y, text);
			doc.addImage(src, 'PNG', 20, 14, 65, 65);
			doc.text((doc.internal.pageSize.width / 2 - 10), 87, subText == null || subText == '' ? '' : subText);

			if(i < (images.length - 1))	doc.addPage();
		}
		doc.save('QRPallet.pdf');
		this.soDoKhoService.setNumOfQRPallet(max).subscribe(res => {
			if(res && res.status == 1){
				if(Number(this.textMaxNum) < Number(max)){
					this.textMaxNum = max;
					this.changeDetect.detectChanges();
				}
			}
		})
	}
    /* -----------------------------------------------------------------------*/

    /*---------------------- HÀM HỖ TRỢ FORMAT DẠNG SỐ -----------------------*/
    ValidateChangeNumberEvent(columnName:string, item:any, event: any) {
		var count = 0;
		for(let i = 0; i < event.target.value.length; i++){
			if(event.target.value[i] == '.'){
				count += 1;
			}
		}
		var regex = this.CONFIG.REGEX_SPECIAL_CHARACTER;
		var found = event.target.value.match(regex);
		if (found != null) {
			const message = 'Dữ liệu không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Dữ liệu không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}
	pad(str: any, max: any) {
        str = str.toString();
        return str.length < max ? this.pad("0" + str, max) : str;
	}
    /* -----------------------------------------------------------------------*/
    
	
	/*Đóng dialog và cập nhập lại tình trạng, trả về highlight ID nếu có*/
	back(){
		this.dialogRef.close()
	}
	changeDetectView() {
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}
	/*------------------------------------------------------------- */
}